import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import { StellarTheme } from '@lavu-pos/stellar';
import { colors } from '@lavu-pos/stellar/dist/themes';
import { CANCEL } from './constants';

const StyledConfirmationModal = styled(Dialog)`
	.confimation-modal-title {
		margin: 0;
		padding: 10px 15px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid ${colors['gray-medium']};
	}
	.confirmation-modal-actions {
		margin: 0;
		padding: 5px;
		border-top: 1px solid ${colors['gray-medium']};
		min-height: 60px;
		button {
			font-size: 14px;
		}
	}
	.confirmation-modal-question {
		padding: 50px 70px;
	}
`;

class ConfirmationModal extends Component {
	static defaultProps = {
		cancelText: CANCEL,
		title: '',
		question: '',
		confirmation: '',
		noCloseButton: false,
		elementId: 'confirmation-modal',
	};

	static propTypes = {
		open: PropTypes.bool.isRequired,
		onClose: PropTypes.func.isRequired,
		onConfirm: PropTypes.func.isRequired,
		title: PropTypes.node,
		cancelText: PropTypes.node,
		question: PropTypes.node,
		confirmation: PropTypes.node,
		loading: PropTypes.bool,
		children: PropTypes.oneOfType([
			PropTypes.arrayOf(PropTypes.node),
			PropTypes.node,
			PropTypes.string,
		]),
		noCloseButton: PropTypes.bool,
		elementId: PropTypes.string,
		nested: PropTypes.bool,
	};

	handleConfirm = async () => {
		const { onClose, onConfirm, nested } = this.props;

		await onConfirm();
		if (!nested) {
			onClose();
		}
	};

	render() {
		const {
			elementId,
			open,
			onClose,
			title,
			question,
			confirmation,
			loading,
			children,
			cancelText,
			noCloseButton,
		} = this.props;

		return (
			open && (
				<MuiThemeProvider theme={StellarTheme}>
					<StyledConfirmationModal open={open} onClose={onClose} id={elementId}>
						<DialogTitle disableTypography className="confimation-modal-title">
							<Typography variant="h6" id={`${elementId}-title`}>
								{title}
							</Typography>
							<IconButton
								onClick={onClose}
								id={`${elementId}-closeIcon`}
								color="inherit"
							>
								<CloseIcon />
							</IconButton>
						</DialogTitle>
						{children || (
							<Typography
								id={`${elementId}-question`}
								className="confirmation-modal-question"
								variant="body1"
								gutterBottom
								align="center"
							>
								{question}
							</Typography>
						)}
						<DialogActions className="confirmation-modal-actions">
							{!noCloseButton && (
								<Button id={`${elementId}-cancel-button`} onClick={onClose}>
									{cancelText}
								</Button>
							)}
							<Button
								id={`${elementId}-confirm-button`}
								variant="contained"
								color="primary"
								onClick={this.handleConfirm}
								disabled={loading}
							>
								{confirmation}
							</Button>
						</DialogActions>
					</StyledConfirmationModal>
				</MuiThemeProvider>
			)
		);
	}
}

export default withMobileDialog()(ConfirmationModal);
